import React from "react";
import AuditLogsContent from "../../components/Settings/AuditLogsContent";

const AuditLogs = () => <AuditLogsContent />;

export default AuditLogs;
